import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import httpClient from "../../services/httpClient";
import Logger from "../../utils/Logger";
import { useAuth } from "../../AuthContext";
import orangeSortIcon from "../../media/orange-sort-icon.svg";
import "../../styleSheet/main/admin/manageRooms/manageRooms.scss";

const randomHexColor = () =>
  "#" + Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, "0");

const AddRoom = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    colorHex: randomHexColor(),
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hover, setHover] = useState(false);
  const navigate = useNavigate();
  const { userData } = useAuth();

  useEffect(() => {
    if (userData.userRole !== "admin") {
      navigate("/");
    }
  }, [userData, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Wyczyść błąd dla tego pola
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Nazwa sali jest wymagana";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email jest wymagany";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Nieprawidłowy format email";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    try {
      await httpClient.post(
        "/Rooms",
        {
          name: formData.name.trim(),
          email: formData.email.trim().toLowerCase(),
          colorHex: formData.colorHex,
        },
        { withAuth: true },
      );

      Logger.log("Sala dodana pomyślnie");
      navigate("/administrator/sale-konferencyjne");
    } catch (err) {
      Logger.error("Błąd podczas dodawania sali:", err);
      setErrors({
        submit:
          err.response?.data?.message ||
          "Nie udało się dodać sali. Spróbuj ponownie.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleBackClick = () => {
    navigate("/administrator/sale-konferencyjne");
  };

  return (
    <div className="manage-rooms-container">
      <div className="manage-rooms-header">
        <h1>Dodaj nową salę konferencyjną</h1>
        <div
          className="orange-sort-icon"
          onClick={handleBackClick}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          style={{
            backgroundImage: `url(${orangeSortIcon})`,
            transform: hover ? "rotate(180deg)" : "rotate(90deg)",
            cursor: "pointer",
          }}
        />
      </div>

      <form onSubmit={handleSubmit} className="room-form">
        <div className="form-group">
          <label htmlFor="name">Nazwa sali</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            disabled={isSubmitting}
          />
          {errors.name && <span className="error-message">{errors.name}</span>}
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            disabled={isSubmitting}
          />
          {errors.email && (
            <span className="error-message">{errors.email}</span>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="colorHex">Kolor</label>
          <input
            type="color"
            id="colorHex"
            name="colorHex"
            value={formData.colorHex}
            onChange={handleChange}
            disabled={isSubmitting}
          />
        </div>

        {errors.submit && (
          <div className="error-message submit-error">{errors.submit}</div>
        )}

        <div className="form-actions">
          <button
            type="submit"
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Dodawanie..." : "Dodaj salę"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddRoom;
